<template>
  <div>
    <file-list :fileList="fileList"></file-list>
  </div>
</template>

<script>
import fileList from "../../components/fileList";
export default {
  name: "",
  components: { fileList },
  props: {},
  data() {
    return {
      fileList: [
        { name: "山西省职业院校铸魂育人-比赛通知.pdf", byte: "547KB" },
        // { name: "申报手册-学校.pdf", byte: "547KB" },
        // { name: "申报手册-中职院校.pdf", byte: "2.2KB" },
        // { name: "申报手册-技工学校.pdf", byte: "1.2KB" },
      ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    const file = JSON.parse(window.sessionStorage.getItem('departs'))[0].oneFiles
    this.fileList = file.split(',').map(item => {
      let pos = item.lastIndexOf(".");
      let lastName = item.substring(pos, item.length);
      return {
        name:item,
        fileType:this.getFileType(lastName)
      }
    })
  },
  methods: {
    getFileType(v){
      const types = new Map([
        ['.pdf',1],
        ['.docx',2],
        ['.doc',1],
      ])
      return types.get(v)
    },
  },
};
</script>

<style scoped lang="scss"></style>
